import React from 'react'
import './Home.css'
import './bootstrap.min.css';
import Product from './Product';

function Home() {
    return (
        <div className="home">
             <section className="banner">
                <div className="container">
                    <div className="row">
                        <img src="images/banner.jpg" alt=""/>
                    </div>
                </div>
            </section>

            <div className="container">
                <div className="row row1">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 product">
                        <Product 
                            id="1"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex eveniet, harum error."
                            price={65.20}
                            image="images/product1.jpg"
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 product">
                        <Product 
                            id="2"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex eveniet, harum error."
                            price={40.50}
                            image="images/product6.jpg"
                        />
                    </div>
                </div>

                <div class="row row2">
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 product">
                        <Product
                            id="3"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex eveniet, harum error."
                            price={70.30}
                            image="images/product3.jpg"
                        />
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 product">
                        <Product
                            id="4"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex eveniet, harum error."
                            price={50.45}
                            image="images/product4.jpg"
                        />
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-12 col-lg-4 product">
                        <Product
                            id="5"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex."
                            price={30.00}
                            image="images/product5.jpg"
                        />
                    </div>
                </div>

                <div class="row row3">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12  product">
                        <Product
                            id="5"
                            title="Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed iure nam ratione iste autem natus illo ex eveniet, harum error."
                            price={150.10}
                            image="images/product2.jpg"
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Home
